// @flow

import * as React from 'react';
import {Executable} from './_executable';
import {useStripeClui} from '../helpers/react/provider';

const Clear = () => {
  const {updatePane} = useStripeClui();
  React.useEffect(() => {
    updatePane({pane: {history: []}});
  }, [updatePane]);
  return '';
};

export class clear extends Executable {
  commandName(): string {
    return 'clear';
  }

  help(): React.Node {
    this.setAllowInput(true);
    return 'clears all prior text from the shell';
  }

  run(): React.Node {
    this.setAllowInput(true);
    return <Clear />;
  }
}
